import type { Locale } from "./catalogs.js";

const ar = {
  title: "أداء جديد",
  description: "اختر الواجبات المراد أداؤها.",
  family: "الواجب",
  original: "المبلغ الأصلي",
  action: "التعديل",
  net: "المبلغ المستحق",
  settled: "المؤدى",
  remaining: "المتبقي",
  due: "تاريخ الاستحقاق",
  overdue: "متأخر",
  future: "قادم",
  paid: "مؤدى",
  partial: "جزئي",
  details: "التفاصيل",
  start: "أداء جديد",
  history: "سجل الأداءات",
  readOnly: "نهائي",
  amount: "المبلغ",
  selectionTitle: "اختر الواجبات",
  selectionHelp: "اختر التسجيل أو الأشهر المراد أداؤها.",
  registration: "التسجيل",
  selectedTotal: "المجموع",
  choosePeriod: "اختر واجباً واحداً على الأقل.",
  adjust: "تعديل التخصيص",
  useSelection: "متابعة",
  allocationTitle: "توزيع المبلغ",
  allocationHelp: "عدّل المبلغ المخصص لكل واجب عند الحاجة.",
  allocated: "المخصص",
  exact: "مجموع التخصيص مطابق للمبلغ.",
  excess: "راجع المبالغ المخصصة.",
  continue: "متابعة",
  back: "رجوع",
  methodTitle: "طريقة الأداء",
  cash: "نقداً",
  cheque: "شيك",
  transfer: "تحويل",
  receivedDate: "تاريخ الاستلام",
  backdatingReason: "سبب اختيار تاريخ سابق",
  backdatingHint: "أدخل سبباً مختصراً.",
  note: "ملاحظة اختيارية",
  chequeNumber: "رقم الشيك",
  bank: "البنك",
  drawer: "صاحب الشيك",
  sender: "صاحب الحساب",
  transferReference: "مرجع التحويل",
  statedDate: "تاريخ التحويل",
  pendingHelp: "سيصدر إشعار استلام إلى حين تأكيد وسيلة الأداء.",
  clockWarning: "تحقق من تاريخ الجهاز قبل المتابعة.",
  confirmTitle: "مراجعة الأداء",
  confirmHelp: "راجع المبلغ والطريقة قبل التأكيد.",
  finalizeCash: "تأكيد وإصدار الوصل",
  finalizePending: "تأكيد وإصدار الإشعار",
  writing: "جارٍ تسجيل الأداء…",
  failure: "تعذّر تسجيل الأداء. لم يتم حفظ أي تغيير.",
  testFailure: "اختبار فشل الحفظ",
  newPayment: "أداء آخر",
  close: "إغلاق",
  showAll: "عرض الكل",
  showLess: "عرض أقل",
  queued: "في انتظار المزامنة",
  syncing: "جارٍ إجراء المزامنة",
  synced: "تمت المزامنة",
  failed: "تعذّرت المزامنة. ستتم إعادة المحاولة تلقائياً.",
  rejected: "تحتاج العملية إلى مراجعة مدير النظام.",
  reason_OVER_ALLOCATED: "تعارض في المبلغ المخصص.",
  reason_INSTALLATION_REVOKED: "هذا الجهاز غير مرخص.",
  reason_IDENTITY_COLLISION: "تعذر مطابقة العملية المسجلة.",
  reason_REFERENCE_COLLISION: "مرجع الأداء مستخدم في عملية أخرى.",
  reason_OBLIGATION_MISSING: "أحد الواجبات لم يعد متاحاً.",
  reason_OBLIGATION_CHANGED: "تغيّر أحد الواجبات منذ آخر مزامنة.",
  reason_ACTOR_DISABLED: "هذا الحساب غير نشط.",
  captureBlocked: "زامن التطبيق قبل تسجيل أداء جديد.",
  invalid: "راجع المبلغ والحقول المطلوبة.",
} as const;

const fr = {
  title: "Nouveau paiement",
  description: "Sélectionnez les frais à régler.",
  family: "Frais",
  original: "Montant initial",
  action: "Ajustement",
  net: "Montant dû",
  settled: "Réglé",
  remaining: "Restant",
  due: "Échéance",
  overdue: "En retard",
  future: "À venir",
  paid: "Réglé",
  partial: "Partiel",
  details: "Détails",
  start: "Nouveau paiement",
  history: "Historique des paiements",
  readOnly: "Finalisé",
  amount: "Montant",
  selectionTitle: "Choisir les frais",
  selectionHelp: "Sélectionnez l’inscription ou les mois à régler.",
  registration: "Inscription",
  selectedTotal: "Total",
  choosePeriod: "Sélectionnez au moins un élément.",
  adjust: "Modifier l’affectation",
  useSelection: "Continuer",
  allocationTitle: "Répartir le montant",
  allocationHelp: "Ajustez le montant attribué à chaque frais si nécessaire.",
  allocated: "Affecté",
  exact: "Le total affecté correspond au montant.",
  excess: "Vérifiez les montants affectés.",
  continue: "Continuer",
  back: "Retour",
  methodTitle: "Mode de paiement",
  cash: "Espèces",
  cheque: "Chèque",
  transfer: "Virement",
  receivedDate: "Date de réception",
  backdatingReason: "Motif de la date antérieure",
  backdatingHint: "Saisissez un motif bref.",
  note: "Note facultative",
  chequeNumber: "Numéro du chèque",
  bank: "Banque",
  drawer: "Titulaire du chèque",
  sender: "Titulaire du compte",
  transferReference: "Référence du virement",
  statedDate: "Date du virement",
  pendingHelp: "Un accusé de réception sera émis jusqu’à la confirmation du moyen de paiement.",
  clockWarning: "Vérifiez la date de l’appareil avant de continuer.",
  confirmTitle: "Vérifier le paiement",
  confirmHelp: "Vérifiez le montant et le mode avant de confirmer.",
  finalizeCash: "Confirmer et émettre le reçu",
  finalizePending: "Confirmer et émettre l’accusé",
  writing: "Enregistrement du paiement…",
  failure: "Le paiement n’a pas été enregistré. Aucune modification n’a été conservée.",
  testFailure: "Tester l’échec d’enregistrement",
  newPayment: "Autre paiement",
  close: "Fermer",
  showAll: "Tout afficher",
  showLess: "Afficher moins",
  queued: "En attente de synchronisation",
  syncing: "Synchronisation en cours",
  synced: "Synchronisé",
  failed: "La synchronisation a échoué. Une nouvelle tentative sera effectuée.",
  rejected: "Cette opération doit être vérifiée par l’administrateur système.",
  reason_OVER_ALLOCATED: "Le montant affecté est en conflit.",
  reason_INSTALLATION_REVOKED: "Cet appareil n’est plus autorisé.",
  reason_IDENTITY_COLLISION: "L’opération enregistrée ne correspond pas.",
  reason_REFERENCE_COLLISION: "Cette référence appartient à une autre opération.",
  reason_OBLIGATION_MISSING: "Un frais n’est plus disponible.",
  reason_OBLIGATION_CHANGED: "Un frais a changé depuis la dernière synchronisation.",
  reason_ACTOR_DISABLED: "Ce compte n’est plus actif.",
  captureBlocked: "Synchronisez l’application avant d’enregistrer un paiement.",
  invalid: "Vérifiez le montant et les champs obligatoires.",
} as const satisfies Record<keyof typeof ar, string>;

export type PaymentMessageKey = keyof typeof ar;

export function paymentMessages(locale: Locale): Record<PaymentMessageKey, string> {
  return locale === "ar" ? ar : fr;
}
